import React, { useState, useContext } from 'react';
import Navbar from '../components/Navbar';
import InnerLeadBanner from '../components/InnerLeadBanner';
import { Link } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const Login = () => {
  let { loginUser } = useContext(AuthContext);

  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });

  const [submissionError, setSubmissionError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionError('');
    setLoading(true);

    try {
      if (formData.username && formData.password) {
        const statusCode = await loginUser(formData.username, formData.password);
        if (statusCode !== 200) {
          setSubmissionError('Login failed. Please check your credentials.');
        }
      }
    } catch (err) {
      setSubmissionError('Something went wrong. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Spinner CSS */}
      <style>
        {`
          .spinner {
            border: 3px solid rgba(255, 255, 255, 0.3);
            border-top: 3px solid #fff;
            border-radius: 50%;
            width: 16px;
            height: 16px;
            animation: spin 0.7s linear infinite;
            display: inline-block;
            vertical-align: middle;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

      <Navbar />
      <InnerLeadBanner title="Login Form" />
      <section className="contact-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="contact-title">Fill in to Login</h2>
            </div>
            <div className="col-lg-8">
              <form className="form-contact contact_form" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <input
                        className="form-control"
                        name="username"
                        type="text"
                        value={formData.username}
                        onChange={handleChange}
                        placeholder="Username"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <input
                        className="form-control"
                        name="password"
                        type="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="Password"
                      />
                    </div>
                  </div>
                </div>

                {submissionError && (
                  <div className="form-group">
                    <p style={{ color: 'red' }}>{submissionError}</p>
                  </div>
                )}

                <div className="form-group mt-3">
                  <button
                    type="submit"
                    className="button button-contactForm boxed-btn"
                    disabled={loading}
                  >
                    Login {loading && <span className="spinner" style={{ marginLeft: '8px' }}></span>}
                  </button>
                </div>
              </form>

              <small>
                Don't have an account?{' '}
                <Link style={{ color: 'blue' }} to="/register">
                  Register
                </Link>
              </small>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
